export type CsBroadcastPayload = {
  title: string;
  body: string;
  imageUrl?: string;
};

export function parseCsBroadcastContent(content: string): CsBroadcastPayload | null {
  if (!content?.trim()) return null;
  try {
    const raw = JSON.parse(content) as Partial<CsBroadcastPayload>;
    const title = String(raw.title ?? "").trim();
    const body = String(raw.body ?? "").trim();
    const imageUrl = String(raw.imageUrl ?? "").trim();
    if (!title && !body && !imageUrl) return null;
    return {
      title,
      body,
      imageUrl: imageUrl || undefined,
    };
  } catch {
    return null;
  }
}

export function truncateCsBroadcastBody(body: string, max = 50): string {
  const text = body.trim();
  if (text.length <= max) return text;
  return `${text.slice(0, max)}...`;
}
